import {
  HTTP_YEAR_FETCHING,
  HTTP_YEAR_SUCCESS,
  HTTP_YEAR_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_YEAR_FETCHING:
      return { ...state, result: [], isLoading: true, isError: false };
    case HTTP_YEAR_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_YEAR_FAILED:
      return { ...state, isLoading: false, isError: true };
    default:
      return state;
  }
};
